/** 埋点类型 */
export enum TrackingTrackType {
  Click = 1, // 仅点击
  Exposure = 2, // 仅曝光
  Both = 3, // 曝光+点击（成组）
}
export const TrackingTrackTypeText = {
  [TrackingTrackType.Click]: '仅点击',
  [TrackingTrackType.Exposure]: '仅曝光',
  [TrackingTrackType.Both]: '曝光+点击',
};

/** 端 */
export enum TrackingClientType {
  PC = 1, // PC
  Mobile = 2, // 移动
}
export const TrackingClientTypeText = {
  [TrackingClientType.PC]: 'PC',
  [TrackingClientType.Mobile]: '移动',
};

/** 埋点业务状态 */
export enum TrackingPointStatus {
  Published = 1, // 已发布
  Disabled = 2, // 已停用
  Invalid = 3, // 前端：已失效
}
export const TrackingPointStatusText = {
  [TrackingPointStatus.Published]: '已发布',
  [TrackingPointStatus.Disabled]: '已停用',
  [TrackingPointStatus.Invalid]: '已失效',
};

/** 工作台本地态：扫描到元素在弹层/下拉内 */
export const TRACKING_POINT_NOT_VISIBLE = 100;
export const TRACKING_POINT_NOT_VISIBLE_TEXT = '当前不可见';

/** 工作台本地态：跳过、超时或缺少定位信息 */
export const TRACKING_POINT_UNSCANNED = 101;
export const TRACKING_POINT_UNSCANNED_TEXT = '未扫描';

/** 全站埋点约定 pagePath，采集时任意页面都匹配 */
export const TRACKING_GLOBAL_PAGE_PATH = '/';

/** 上报事件类型 */
export enum TrackingEventType {
  Click = 1, // 点击
  Exposure = 2, // 曝光
}
